import { useMemo } from "react";

const CHART_TYPES = {
  tarefas: { datasets: ["tarefas", "tarefasAbertas"], titulo: "Quantidade de Tarefas", isLegendVisible: true },
  tempo: { datasets: ["tempoMedioConclusao"], titulo: "Tempo Médio de Execução", isLegendVisible: false },
};

const DATASET_CONFIG = {
  tarefas: {
    id: "tarefas",
    titulo: "Total",
    tituloModal: "Total geral de itens",
    unitKey: "itens",
    barOpacity: "cf",
  },

  tarefasAbertas: {
    id: "tarefasAbertas",
    titulo: "Em Aberto",
    tituloModal: "Total de itens em aberto",
    unitKey: "itens",
    barOpacity: "01",
  },

  tempoMedioConclusao: {
    id: "tempoMedioConclusao",
    titulo: "Tempo Médio Total",
    tituloModal: "Tempo médio de execução",
    unitKey: "dias",
    divisor: 86400000,
    barOpacity: "cf",
  },
};

export default function useWorkflowBarChart(resumoTarefas) {
  const coresPayload = useMemo(() => resumoTarefas.map((item) => `#${item.cor}`), [resumoTarefas]);
  const membersMap = useMemo(() => Object.fromEntries(resumoTarefas.map((i) => [i.nome, { membros: i.membros, tarefasTotal: i.tarefas, tarefasAbertasTotal: i.tarefasAbertas }])), [resumoTarefas]);

  function buildDatasets(tipoGrafico) {
    const selected = CHART_TYPES[tipoGrafico].datasets;

    return selected.map((key) => {
      const cfg = DATASET_CONFIG[key];
      const mappedDataset = resumoTarefas.map((item) => item[key] !== 0 && item[key] / (cfg.divisor ?? 1));

      return {
        type: "bar",
        label: cfg.titulo,
        data: mappedDataset,
        backgroundColor: coresPayload.map((c) => `${c}${cfg.barOpacity}`),
        borderColor: coresPayload,
        borderWidth: 1.5,
        barPercentage: 0.8,
        categoryPercentage: 0.6,
        pointStyle: "rect",
        internalKey: key,
        config: cfg,
      };
    });
  }

  function buildModalInfo(nomeTarefa, tipoDataset, config, indexCor, valorChart) {
    return {
      nomeTarefa,
      tipoDataset,
      tarefaDetailsByNomeTarefa: membersMap[nomeTarefa],
      colorTipo: coresPayload[indexCor],
      chartCfg: config,
      valorChart,
    };
  }

  function getTituloGrafico(tipoGrafico) {
    return CHART_TYPES[tipoGrafico].titulo ?? [];
  }

  function getLegendVisible(tipoGrafico) {
    return CHART_TYPES[tipoGrafico].isLegendVisible;
  }

  return { coresPayload, membersMap, getTituloGrafico, getLegendVisible, buildDatasets, buildModalInfo };
}
